import React, { useEffect } from "react";

import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import Input from "../../components/form/Input";

import type { JSX } from "react";

import type { CarouselComponent } from "../../api/ProjectAPI.types";

const DEFAULT_COLOR = "#FFFFFF";

interface CarouselComponentCustomizeProps {
  onChange: (
    option: "withCustomization" | "backgroundColor" | "itemBorderColor",
    value: string | boolean,
  ) => void;
  component: CarouselComponent;
}

function CarouselComponentCustomize({
  onChange,
  component,
}: CarouselComponentCustomizeProps): JSX.Element {
  const { t } = useTranslation("editor-platform");
  const methods = useForm({
    values: {
      withCustomization: component.params.withCustomization ?? false,
      backgroundColor: component.params.backgroundColor ?? DEFAULT_COLOR,
      itemBorderColor: component.params.itemBorderColor ?? DEFAULT_COLOR,
    },
  });

  useEffect(() => {
    const formValuesWatch = methods.watch((values, { name }) => {
      if (name && values[name] !== undefined) {
        onChange(name, values[name]);
      }
    });

    return () => {
      formValuesWatch.unsubscribe();
    };
  }, [methods, onChange]);

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <FormProvider {...methods}>
      <Input
        isCompact
        isNoWrap
        isReversed
        label={t("activeCustomization")}
        name="withCustomization"
        size="sm"
        type="switch"
      />
      <Input
        isCompact
        isReadOnly={!component.params.withCustomization}
        label={t("backgroundColor")}
        name="backgroundColor"
        type="color"
      />
      <Input
        isCompact
        isReadOnly={!component.params.withCustomization}
        label={t("itemBorderColor")}
        name="itemBorderColor"
        type="color"
      />
    </FormProvider>
  );
}

export default CarouselComponentCustomize;
